import App from '../App'
import Vue from 'vue'
import Router from 'vue-router'
import {getSessionStore, setSessionStore, getLocalStore, setLocalStore, clearLocalStore} from "../services/utils/mUtils";

Vue.use(Router)

const homeHead = r => require.ensure([], () => r(require('../components/header/homehead')), 'homeHead');
const simpleHead = r => require.ensure([], () => r(require('../components/header/simplehead')), 'simpleHead');
const foot = r => require.ensure([], () => r(require('../components/footer/foot')), 'foot');
const home = r => require.ensure([], () => r(require('../page/home')), 'home');
const login = r => require.ensure([], () => r(require('../page/login')), 'login');
const god = r => require.ensure([], () => r(require('../page/god')), 'god');
const godlist = r => require.ensure([], () => r(require('../page/godlist')), 'godlist');
const article = r => require.ensure([], () => r(require('../page/article')), 'article');

const routes = [
  {
    path: '/',
    component: App, // 顶层路由，对应index.html
    children: [ // 二级路由。对应App.vue
      // 地址为空时跳转home页面
      {
        path: '',
        redirect: '/home'
      },
      // 首页
      {
        path: '/home',
        name: 'home',
        meta: {
          requireAuth: false // 添加该字段，表示进入这个路由是需要登录的
        },
        components: {
          trdpage: home,
          header: homeHead,
          footer: foot
        }
      },
      // 首页
      {
        path: '/login',
        name: 'login',
        meta: {
          requireAuth: false // 添加该字段，表示进入这个路由是需要登录的
        },
        components: {
          trdpage: login,
          footer: foot
        }
      },
      // 商品详情
      {
        path: '/god',
        name: 'god',
        meta: {
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        components: {
          default: god,
          header: homeHead,
          footer: foot
        }
      },
      // 商品搜索页
      {
        path: '/godlist',
        name: 'godlist',
        meta: {
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        components: {
          default: godlist,
          header: simpleHead,
          footer: foot
        }
      }
    ]
  }
];

const router = new Router({
  routes,
  mode: 'history',
  strict: process.env.NODE_ENV !== 'production'
});

router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth) {
    let state = getSessionStore('token');
    if (state) {
      let localState = getLocalStore("state");
      if (localState) {
        let orgInfo = JSON.parse(localState).orgInfo;
        if (orgInfo && orgInfo.fb2bSellCertStatus != 44 && to.fullPath.startsWith("/sal/")) {
          next({
            path: '/memhome'
          })
        } else {
          next()
        }
      } else {
        next()
      }
    } else {
      if (to.query.sk) {
        let api = JSON.parse(JSON.stringify(apiSetting.chkLogin));
        api.url = api.url + "/" + to.query.sk;
        http(api, {}).then(res => {
          if (res.resultType === 'Success') {
            let result = JSON.parse(res.resultJsonStr)
            console.log(result)
            store.commit('SET_TOKEN', result.element.datas.token)
            setSessionStore('token', result.element.datas.token)
            store.commit('SET_SESSIONKEY', result.element.datas.sessionKey)
            setSessionStore('sessionKey', result.element.datas.sessionKey)
            store.commit('SET_USERINFO', result.element.datas.usr || [])
            store.commit('SET_ORGINFO', result.element.shpInfo)
            store.commit('SET_B2BDEFSUPPID', result.element.datas.B2B_DEF_SUPPID)
            store.commit('SET_SHPINFO', result.element.datas.SHP_INFO)
            result.element.datas = undefined
            result.element.shpInfo = undefined
            store.commit('SET_ACCOUNT', result.element)
            setLocalStore('state', JSON.stringify(store.state))
            next()
          }
        })
      } else {
        clearLocalStore();
        next({
          path: '/login',
          query: {redirect: to.fullPath} // 登陆成功后回到当前页面，这里传值给login页面，to.fullPath为当前点击的页面
        })
      }
    }
  } else {
    next()
  }
});

export default router
